import React, { FC } from 'react'
import EditArtworkIcon from 'svg/edit-v3.svg'
import EditArtworkFilledIcon from 'svg/edit-v3-filled.svg'
import styles from './Actions.module.scss'
import classNames from 'classnames'

type EditArtworkProps = {
  artworkId: number
}

const EditArtwork: FC<EditArtworkProps> = ({ artworkId }) => {
  const handleClickEditArtwork = (ev: React.SyntheticEvent<any>) => {
    ev.preventDefault()

    if (window && window.dataLayer) {
      window.dataLayer.push({
        event: 'edit - start',
      })
    }

    window.location.assign(`/studio/art/${artworkId}/image`)
  }

  return (
    <button
      className={classNames(styles.iconButtonDefaultStyle, styles.iconActionContainer)}
      data-type='action'
      rel='nofollow'
      title='Edit Artwork'
      onClick={handleClickEditArtwork}
    >
      <EditArtworkFilledIcon
        className={classNames(styles.iconActionEditArtwork, {
          [styles.iconActionContainerInvisible]: true,
        })}
      />
      <EditArtworkIcon className={styles.iconActionEditArtwork} />
    </button>
  )
}

export default EditArtwork
